import React from 'react';
import PropTypes from 'prop-types';
import {defaultTemplate} from 'core/hoc';
import {BasicInput, BaasicFieldDropdown} from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

const UserCreateTemplate = function ({ userCreateViewStore }) {
    const {
        contentLoading,
        form,
        roleMultiselectStore,
    } = userCreateViewStore;

    return (
        <ApplicationEditLayout store={userCreateViewStore}>
            <Content loading={contentLoading} >
                <React.Fragment>
                    <div className="row">
                        <div className="col col-sml-12 col-lrg-8">
                            <div className="card card--form card--primary card--med">
                                <div className="row">
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('firstName')}/>
                                    </div>
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('lastName')}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('userName')}/>
                                    </div>
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('displayName')}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('userEmail')}/>
                                    </div>
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('confirmUserEmail')}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('password')}/>
                                    </div>
                                    <div className="form__group col col-lrg-6">
                                        <BasicInput field={form.$('confirmPassword')}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form__group col col-lrg-6">
                                        <BaasicFieldDropdown field={form.$('roles')}
                                            store={roleMultiselectStore}/>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </React.Fragment>
            </Content>
        </ApplicationEditLayout>
    )
};

UserCreateTemplate.propTypes = {
    userCreateViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(UserCreateTemplate);
